import { render, staticRenderFns } from "./PolicyDetailNew.vue?vue&type=template&id=52fd6e5e"
import script from "./PolicyDetailNew.vue?vue&type=script&lang=js"
export * from "./PolicyDetailNew.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports